import { render } from "./ReportRemainingGood.vue?vue&type=template&id=0a64431b"
import script from "./ReportRemainingGood.vue?vue&type=script&lang=js"
export * from "./ReportRemainingGood.vue?vue&type=script&lang=js"

import "./ReportRemainingGood.vue?vue&type=style&index=0&id=0a64431b&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__